import React, { useEffect, useState } from "react";

type Props = {
    id: string;
    name?: string;
    type?: "text" | "email" | "number" | "search";
    label?: string;
    placeholder?: string;
    required?: boolean;
    onChange?: (value: string) => void;
    containerClasses?: string;
};

const Input = (props: Props) => {
    const {
        id,
        name,
        type,
        placeholder,
        label,
        required,
        onChange,
        containerClasses="mb-6 lg:mb-10"
    } = props;

    const [value, setValue] = useState("");
    const [focused, setFocused] = useState(false);

    // Including onChange as dep here will cause loop, rendering this input unusable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => onChange?.(value), [value]);

    let inputPadding: string, labelClasses = "";

    if (label?.length) {
        if (focused || value.length > 0) {
            inputPadding = "pt-9 pb-4";
            labelClasses = "top-0 mt-3 transform-none text-sm";
        }
        else {
            inputPadding = "py-7";
            labelClasses = "top-1/2 mt-0 text-lg";
        }

        if (focused) {
            labelClasses += " text-brand-primary-50";
        }
        else {
            labelClasses += " text-label";
        }
    }
    else {
        inputPadding = "py-4";
    }

    return (
        <div className={`relative w-full ${containerClasses}`}>
            {label && (
                <label
                    htmlFor={id}
                    className={`${labelClasses} absolute left-0 ml-4 transform transition-all duration-100 -translate-y-1/2 pointer-events-none`}
                >
                    {label}{required ? "*" : "" }
                </label>
            )}
            <input
                id={id}
                name={name ?? id}
                className={`${inputPadding} w-full px-4 outline-none text-brand-primary-20 text-lg rounded border border-input-border focus:border-input-border-focused`}
                placeholder={!label?.length || focused ? placeholder : undefined}
                type={type ?? "text"}
                value={value}
                required={required}
                onFocus={() => setFocused(true) }
                onBlur={() => setFocused(false) }
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
            />
        </div>
    );
};

export default Input;
